<template>
  <q-card class="bg-grey-2">
    <q-card-title>
      {{ template.name }}
    </q-card-title>
    <q-card-separator />
    <q-card-main class="bg-grey-1 scroll" style="max-height: 200px">
      <div v-html="template.content"></div>
    </q-card-main>
    <q-card-separator />
    <q-card-actions class="bg-grey-1 justify-between">
      <div>
        <q-btn :label="$t('edit')" flat @click="$emit('edit')" />
        <q-btn :label="$t('delete')" flat @click="$emit('delete')" />
      </div>
      <q-btn :label="$t('apply')" color="primary" flat @click="$emit('apply', template.content)" />
    </q-card-actions>
  </q-card>
</template>

<script>
  export default {
    props: {
      template: {
        type: Object,
        required: true
      }
    },
    computed: {
      preview () {
        const content = this.template.content
          .replace(/[\r\n]/g, ' ')
          .trim()

        return content
      }
    }
  }
</script>
